"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _timers = require("./timers");

var _constants = require("./constants");

var _countdowns = require("./countdowns");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeSync = function TimeSync() {
  _classCallCheck(this, TimeSync);

  _defineProperty(this, "addTimer", void 0);

  _defineProperty(this, "revalidate", void 0);

  _defineProperty(this, "removeAllTimers", void 0);

  _defineProperty(this, "createCountdown", void 0);

  _defineProperty(this, "stopAllCountdowns", void 0);

  _defineProperty(this, "getCurrentTime", void 0);

  _defineProperty(this, "getTimeLeft", void 0);

  var timers = new _timers.Timers();
  var countdowns = new _countdowns.Countdowns();
  this.addTimer = timers.addTimer;
  this.revalidate = timers.revalidate;
  this.removeAllTimers = timers.removeAllTimers;
  this.createCountdown = countdowns.createCountdown;
  this.stopAllCountdowns = countdowns.stopAllCountdowns;
  this.getCurrentTime = _timers.getCurrentTime;
  this.getTimeLeft = _countdowns.getTimeLeft;
};

exports.default = TimeSync;

_defineProperty(TimeSync, "SECONDS", _constants.Interval.SECONDS);

_defineProperty(TimeSync, "MINUTES", _constants.Interval.MINUTES);

_defineProperty(TimeSync, "HOURS", _constants.Interval.HOURS);

_defineProperty(TimeSync, "DAYS", _constants.Interval.DAYS);

_defineProperty(TimeSync, "getCurrentTime", _timers.getCurrentTime);

_defineProperty(TimeSync, "getTimeLeft", _countdowns.getTimeLeft);